import { Slot } from "radix-ui";

import { Loader } from "../loader";
import { getButtonClass } from "./button.styles";
import type { ButtonProps } from "./button.types";

export function Button({
  ref,
  children,
  className,
  variant,
  size,
  asChild = false,
  loading = false,
  disabled,
  ...props
}: ButtonProps & { ref?: React.RefObject<HTMLButtonElement | null> }) {
  const Comp = asChild ? Slot.Root : "button";
  const isLoading = loading && !disabled;

  return (
    <Comp ref={ref} disabled={disabled ?? loading} className={getButtonClass({ variant, size, className })} {...props}>
      {isLoading ? <Loader className="mr-2 size-4" /> : null}
      <Slot.Slottable>{children}</Slot.Slottable>
    </Comp>
  );
}
Button.displayName = "Button";
